/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: InvoicesModule
 * Purpose		: Module for Invoices.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { InvoicesService } from './Invoices.service';
import { InvoicesListComponent } from './InvoicesList.component';
import { InvoicesSearchComponent } from './InvoicesSearch.component';
import { InvoicesDetailsComponent } from './InvoicesDetails.component';

import { InvoicesRoutingModule } from './Invoices-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    InvoicesRoutingModule
  ],
  declarations: [
    InvoicesListComponent,
	InvoicesSearchComponent,
	InvoicesDetailsComponent
  ],
  providers: [
    InvoicesService
  ]
})

export class InvoicesModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Invoices/Invoices.module.ts